import React, { useState } from "react";
import {
  Flex,
  Text,
  Button,
  Modal,
  Stack,
  NumberFormatter,
} from "@mantine/core";

const OdometerMismatchModal = ({
  userValue,
  dealerValue,
  onSubmit,
  onClose,
}) => {
  const [confirmValue, setConfirmValue] = useState(null);

  return (
    <Modal opened centered withCloseButton={false} onClose={() => null}>
      <Stack gap="xs">
        {confirmValue ? (
          <>
            <Stack gap="xs">
              <Text size="lg" align="center">
                The correct odometer reading is{" "}
                <NumberFormatter
                  value={confirmValue.value}
                  thousandSeparator
                  style={{ fontWeight: 600 }}
                />{" "}
                which has been supplied by
                {confirmValue.type === "customer" ? " the customer" : " me"}.
              </Text>
              <Button
                onClick={() => onSubmit(parseInt(confirmValue.value))}
                color="green"
              >
                Confirm
              </Button>
              <Flex justify="center">
                <Button
                  size="xs"
                  color="gray"
                  variant="subtle"
                  onClick={() => setConfirmValue(null)}
                >
                  This is incorrect
                </Button>
              </Flex>
            </Stack>
          </>
        ) : (
          <>
            <Text align="center" size="lg">
              The customer supplied a different mileage reading than you did.
            </Text>
            <Text align="center" size="lg" mb="md" fw={600}>
              Which reading is correct?
            </Text>
            <Button
              onClick={() =>
                setConfirmValue({ type: "customer", value: userValue })
              }
            >
              Customer's reading:{` `}
              <NumberFormatter
                style={{ marginLeft: "4px" }}
                value={userValue}
                thousandSeparator
              />
            </Button>
            <Button
              onClick={() =>
                setConfirmValue({ type: "dealer", value: dealerValue })
              }
            >
              Your reading:{` `}
              <NumberFormatter
                style={{ marginLeft: "4px" }}
                value={dealerValue}
                thousandSeparator
              />
            </Button>
            <Button color="red" onClick={onClose}>
              Neither is correct
            </Button>
          </>
        )}
      </Stack>
    </Modal>
  );
};

export default OdometerMismatchModal;
